var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-h-24 tw-items-center tw-justify-center"},[_c('i',[_vm._v("\n    The block driver does not have any parameters.\n  ")])])
}]

export { render, staticRenderFns }